// extracted by mini-css-extract-plugin
module.exports = {"container":"Partner-module--container--2I-pO","stickyDummy":"Partner-module--stickyDummy--39EbD"};